import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { TomosSection } from './components/TomosSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { PurchaseSection } from './components/PurchaseSection';
import { ClosingSection } from './components/ClosingSection';
import { FaqSection } from './components/FaqSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink antialiased" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainSection data-id="element-3" />
        <TomosSection data-id="element-4" />
        <TestimonialsSection data-id="element-5" />
        <BonusSection data-id="element-6" />
        <PurchaseSection data-id="element-7" />
        <ClosingSection data-id="element-8" />
        <FaqSection data-id="element-9" />
      </main>

      <footer className="bg-sage-deep py-12" data-id="element-10">
        <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-11">
          <p className="font-serif text-lg italic leading-relaxed text-cream/90" data-id="element-12">
            Mega Pack Tiroides — Un sistema de alimentación tiroidea creado para
            que comer bien en Argentina no sea un privilegio ni una confusión
            sino una herramienta concreta al alcance de todas.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-13" />
    </div>;
}